import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';

type WcbCallNowContainerProps = {
    iimclient: ConfigClientType;
    showContainer: boolean;
    wcbCallNow: boolean;
    changeWcbCallNow: Function;
};

const WcbCallNowContainer = ({
    iimclient,
    showContainer,
    wcbCallNow,
    changeWcbCallNow,
}: WcbCallNowContainerProps) => {
    const { segment } = iimclient;
    const callNowLabel = segment.labelcallnow || 'labelcallnow';

    const handleChange = ({ target }) => changeWcbCallNow(target.checked);

    return (
        showContainer && (
            <div className="input-block if checkboxes" id="wcb-callnow-container">
                <input
                    type="checkbox"
                    aria-labelledby="wcb-labelcallnow"
                    id="wcb-callnow"
                    className="if checkbox"
                    checked={wcbCallNow}
                    onChange={handleChange}
                />
                <label htmlFor="wcb-callnow" id="wcb-labelcallnow">
                    {callNowLabel}
                </label>
            </div>
        )
    );
};

export default WcbCallNowContainer;
